import React from "react";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import ServiceLogo from "../components/img/figure_service.png";

const StyledImg = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  objectFit: "cover",
}));

export default function MoreSamplePlease() {
  return (
    <Container maxWidth="sm">
      <Box sx={{
        width: "100%",
        maxWidth: 500,
        my: { xs: 20, md: 15 },
        mx: 0,
      }}>
        <StyledImg
          alt="Please..."
          src={ServiceLogo}
        />
        <Typography sx={{ mt: 2 }} variant="subtitle1" gutterBottom>
            Please Put Something into the Cart First
        </Typography>
        <Typography variant="body1" gutterBottom>
            <Link href="/" color="inherit" underline="hover">
            Back to Home
            </Link>
        </Typography>
      </Box>
    </Container>
  );};